// extracted by mini-css-extract-plugin
export default {"header":"Status-rebranding-module__header___3781f","childrenWrapper":"Status-rebranding-module__childrenWrapper___ZfjuB"};